import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import $ from "jquery";
import Papa from "papaparse";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import XLSX from "xlsx-js-style";
import { Tables } from "../../APIs/Tables.api";
import { Option } from "../../Components/Option";
import { SearchingDataProvider } from "../../Context/SearchingDataContext";
import { IsNumber } from "../../utils/isNumber";
import data_cpn from "../render-cpn/data.json";
import RenderUI from "../render-cpn/render";
import RenderDataDetail from "./detail";
import RenderInputPost from "./input-post";
import RenderInputPut from "./input-put";
import Layout0 from "./layout/layout 0";
import Layout1 from "./layout/layout 1";
import Layout_active from "./layout/layout_active";
import Layout_chart from "./layout/layout_chart";
import Layout_keys from "./layout/layout_keys";
import RenderModal from "../common/modal";
import { set } from "date-fns";

const rowsPerPage = 15;

const COMPONENT = () => {
  const { lang, proxy, auth, pages, functions, database } = useSelector(
    (state) => state
  );
  const [user, setUser] = useState({});
  const stringifiedUser = localStorage.getItem("user");
  const _user = JSON.parse(stringifiedUser) || {};
  // useEffect(() => {
  //   fetch(`${proxy()}/auth/u/${_user}`, {
  //     headers: {
  //       Authorization: _token,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       const { success, data } = resp;
  //       if (success) {
  //         setUser(data);
  //       }
  //     });
  // }, [_user]);
  //////console.log(29, pages)
  const dispatch = useDispatch();
  const { openTab, renderDateTimeByFormat, findPageById } = functions;
  const _token = localStorage.getItem("_token");

  const url = window.location.pathname.slice(1);
  const page_id = url.split("/")[0];

  let navigate = useNavigate();
  const [dataTables, setDataTables] = useState([]);
  const [dataTable_id, setDataTableID] = useState(null);
  const [dataFields, setDataFields] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [countData, setCountData] = useState(0);
  const [dataTo, setDataTo] = useState(0);
  const [dataFrom, setDataFrom] = useState(0);

  const [dataUrlExport, setDataUrlExport] = useState("");
  const [errorSelect, setErrorSelect] = useState(null);
  const [loadingExportFile, setLoadingExportFile] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingResult, setLoadingResult] = useState(false);
  const [uploadedJson, setUploadedJson] = useState(null);
  ////////console.log(46, apiData)
  const currentURL = window.location.href;

  const params = functions.getAllParamsAfterPageId(currentURL, url);
  ////console.log(params);
  const [valueExport, setaValueExport] = useState({});
  const [apiDataName, setApiDataName] = useState([]);
  const [dataStatis, setDataStatis] = useState([]);
  const [export_excel_type, setExport_excel_type] = useState("");
  const [statusActive, setStatusActive] = useState(false);
  const [errorLoadConfig, setErrorLoadConfig] = useState(false);
  const [effectOneCompleted, setEffectOneCompleted] = useState(false);
  const [page, setPage] = useState([]);
  const [dataUi, setDataUi] = useState([]);

  const [apiViewPages, setApiViewPages] = useState([]);

  const [limit, setLimit] = useState(0);

  const [data, setData] = useState({});
  const [selectedFileType, setSelectedFileType] = useState("xlsx");
  const [dataSearch, setdataSearch] = useState([]);
  const [totalSearch, setTotalSearch] = useState(0);
  const [sumerize, setSumerize] = useState(0);
  const [hasSetSumerize, setHasSetSumerize] = useState(false); //lưu count 1 lần
  const [count, setCount] = useState(0);
  const [pagePublic, setPagePublic] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [isExportBtn, setIsExportBtn] = useState(false);
  const [isData, setIsData] = useState();
  const [dataBtnLink, setDataBtnLink] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [renderTable, setRenderTable] = useState(false);
  const [isModalAdd, setModalAdd] = useState(false);
  const [isModal, setModal] = useState(false);
  const [buttonId, setButtonId] = useState("");
  const [isModalTable, setModalTable] = useState(false);
  const isLoadingExportFile = useRef(true);
  const [refreshPage, setRefreshPage] = useState(0);
  const [anotherModal, setAnotherModal] = useState(false);
  const [isPageId, setPageId] = useState();
  const [isParam, setParam] = useState();
  const [paramSearch, setParamSearh] = useState();
  const [paramSearchTable, setParamSearhTable] = useState();
  const [isParamTable, setParamTable] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [getCpnId, setCpnId] = useState("");
  const [dynamicModals, setDynamicModals] = useState([]);
  const [popupStyles, setPopupStyles] = useState({});
  const handleRefreshModal = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const [idModal, setIdModal] = useState();
  const formatNumber = (num) => {
    if (num == null || isNaN(num)) {
      return "0";
    }

    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const formatNumberSize = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("nav-home_s2");

  useEffect(() => {
    if (
      !dataStatis ||
      (dataStatis.length === 0 && activeTab === "nav-profile_s2")
    ) {
      setActiveTab("nav-home_s2");
    }
  }, [dataStatis]);

  useEffect(() => {
    setSearchValues({});
    setLoadingResult(false);
  }, [location.pathname]);

  useEffect(() => {
    fetch(`${proxy()}/auth/activation/check`, {
      headers: {
        Authorization: _token,
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, data, activated, status, content } = resp;
        if (activated) {
          setStatusActive(true);
        } else {
          setStatusActive(false);
        }
        setEffectOneCompleted(true);
      });
  }, []);

  const yourComponentArray =
    data_cpn.data[1]?.children.length > 0
      ? data_cpn.data[1]?.children[0]?.component
      : data_cpn.data[1]?.component;

  useEffect(() => {
    if (pages && pages.length > 0) {
      let newURL = url;
      let result;
      while (newURL) {
        result = functions.findPageById(pages, `${newURL}`);

        if (result && result.component.length > 0) {
          setDataUi(result.component);
          setPage(result);
          return;
        }
        newURL = newURL.slice(0, -1);
      }

      setDataUi([result]);
    }
  }, [pages, url]);

  useEffect(() => {
    if (pages && pages.length > 0) {
      const pagesWithApiView = pages.filter((page) => page.type === "apiview");
      setApiViewPages(pagesWithApiView);
      const filteredPages = pages.filter((page) => page.type !== "apiview");
      const result = filteredPages.find((page) => page.url === `/${url}`);
      if (result) {
        setPage(result);
      } else {
        // openTab('/page/not/found')
      }
    }
  }, [pages, url]);
  useEffect(() => {
    setCurrentPage(1);
  }, [page, url]);

  const layoutId = page.components?.[0].layout_id;
  // ////////console.log(layoutId)
  const tableClassName = layoutId === 0 ? "table" : "table table-hover";

  const CustomFileInput = ({ onChange, ...props }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    const handleButtonClick = (event) => {
      event.preventDefault();
      fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
      event.preventDefault();
      const supportedExtensions = ["csv", "xlsx", "xls"];

      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (supportedExtensions.includes(fileExtension)) {
          setSelectedFile({
            name: file.name,
            size: file.size,
            type: file.type,
            rawFile: file,
          });
          setErrorSelect(null);
        } else {
          setSelectedFile(null);
          setErrorSelect(lang["check file"]);
        }
      }
    };

    function extractValueInBrackets(value) {
      const matches = value.match(/\(([^)]+)\)/);
      return matches ? matches[1] : value;
    }
    const processSelectedFile = (event) => {
      event.preventDefault();
      if (!selectedFile || !selectedFile.rawFile) return;

      const file = selectedFile.rawFile;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          if (fileExtension === "csv") {
            Papa.parse(e.target.result, {
              complete: (result) => {
                const modifiedData = result.data
                  .filter((row) =>
                    Object.values(row).some((value) => value.trim() !== "")
                  )
                  .map((row) => {
                    const newRow = {};
                    for (let key in row) {
                      newRow[extractValueInBrackets(key)] = row[key];
                    }
                    return newRow;
                  });

                // ////////console.log("Parsed CSV Result:", modifiedData);
                setUploadedJson(modifiedData);
                importData();
              },
              header: true,
            });
          } else if (["xlsx", "xls"].includes(fileExtension)) {
            const workbook = XLSX.read(e.target.result, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const json = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            const modifiedData = json.map((row) => {
              const newRow = {};
              for (let key in row) {
                newRow[extractValueInBrackets(key)] = row[key];
              }
              return newRow;
            });
            // ////////console.log("Parsed Excel Result:", modifiedData);
            setUploadedJson({ data: modifiedData });
            importData();
          }
        } catch (error) {
          setErrorSelect(lang["format"]);
        }
      };

      if (fileExtension === "csv") {
        reader.readAsText(file);
      } else {
        reader.readAsBinaryString(file);
      }
    };

    const fileTypeToReadable = (type) => {
      switch (type) {
        case "text/csv":
          return "CSV";
        case "application/vnd.ms-excel":
          return "Excel (XLS)";
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return "Excel (XLSX)";
        default:
          return "Không xác định";
      }
    };

    return (
      <div>
        <input
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
          {...props}
        />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button onClick={handleButtonClick} className="btn btn-primary">
            <i className="fa fa-file-excel-o"></i> {lang["select file"]}
          </button>

          {selectedFile && (
            <button
              className="btn btn-success ml-auto"
              onClick={processSelectedFile}
            >
              {lang["import"]}
            </button>
          )}
        </div>

        {selectedFile && (
          <div className="mt-2">
            <ul>
              <li>
                {" "}
                {lang["selected file"]}: {selectedFile.name}
              </li>
              <li>
                {lang["size"]}:{" "}
                {formatNumberSize((selectedFile.size / 1024).toFixed(0))} KB
              </li>
              <li>
                {lang["type"]}: {fileTypeToReadable(selectedFile.type)}
              </li>
            </ul>
          </div>
        )}
        {errorSelect && <div className="mt-2 text-danger">{errorSelect}</div>}
      </div>
    );
  };

  // ////////console.log(uploadedJson)

  const BATCH_SIZE = 1000;

  const importData = async () => {
    if (!uploadedJson?.data) return;
    let batches = [];
    for (let i = 0; i < uploadedJson.data.length; i += BATCH_SIZE) {
      batches.push(uploadedJson.data.slice(i, i + BATCH_SIZE));
    }
    let logCount = 0;

    for (let batch of batches) {
      const requestBody = {
        data: batch,
        // type: "import"
      };
      logCount++;
      // ////////console.log("Sample batch data:", requestBody);

      try {
        const response = await fetch(
          `${proxy()}${page.components?.[0]?.api_import}`,
          {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        const jsonResponse = await response.json();
        const {
          success,
          content,
          data,
          result,
          total,
          fields,
          statisticValues,
          count,
          sumerize,
        } = jsonResponse;
        // ////////console.log(jsonResponse)
        if (!success) {
          console.error(
            "Server did not process batch successfully:",
            jsonResponse
          );
          break;
        }

        // ////////console.log("Successfully processed batch number:", logCount);
      } catch (error) {
        console.error("Error sending batch:", error);
        break;
      }
    }
  };
  const [dataPrivileges, setDataPrivileges] = useState([]);
  const [userPrivilegesGroup, setUserPrivilegeGroup] = useState();
  // useEffect(() => {
  //   console.log("392");
  //   fetch(`${proxy()}/privileges/accounts`, {
  //     headers: {
  //       Authorization: _token,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       const { success, data } = resp;
  //       if (success && data.length > 0) {
  //         const dataUser = data.find((item) => item.username === user.username);
  //         setDataPrivileges(dataUser?.privileges);
  //         setUserPrivilegeGroup(dataUser?.privilegesGroup);
  //       }
  //     });
  // }, [user]);
  const [privilegesDetail, setPrivilegeDetail] = useState([]);
  // useEffect(() => {
  //   fetch(
  //     `${proxy()}/privileges/group/${
  //       userPrivilegesGroup?.privilegegroup_id
  //     }/ui/tree`,
  //     {
  //       headers: {
  //         Authorization: _token,
  //       },
  //     }
  //   )
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       const { pages } = resp;

  //       if (pages && pages.length > 0) {
  //         setPrivilegeDetail(pages);
  //       }
  //     });
  // }, [userPrivilegesGroup]);

  // ////////console.log(dataPrivileges)
  const dataCheck = dataPrivileges?.find(
    (item) => item.table_id === dataTable_id
  );

  useEffect(() => {
    importData();
  }, [uploadedJson]);

  useEffect(() => {
    if (page) {
      // const id_str = page.components?.[0]?.api_post.split('/')[2];
      const id_str = page.components?.[0]?.api_post.split("/")[2];
      const result = functions.findPostApi(page);

      ////////console.log(456, page)
      ////////console.log(456, result)
      // ////////console.log(id_str)
      fetch(`${proxy()}/apis/api/${result?.split("/")[2]}/input_info`, {
        headers: {
          Authorization: _token,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { data, success, content } = res;
          //////console.log(413, res)

          if (success) {
            // alert("?")
            setDataTables(data.tables);
            setDataTableID(data.tables[0]?.id);
            setDataFields(data.body);
            // setApiDataName(data.fields);
            setLoaded(true);
          }
        });
    }
  }, [page, dataTable_id]);
  // ////////console.log(dataTable_id)
  // ////////console.log(page)
  const handleCloseModal = () => {
    setSelectedFields([]);
    setSelectedStats([]);
    setSelectAll(false);
    setAnotherModal(false);
    // setBtnLink(false)
  };
  const [loaded, setLoaded] = useState(false);

  // ////////console.log(page)
  //search
  const [currentPage, setCurrentPage] = useState(0);

  const [requireCount, setRequireCount] = useState(true);
  const [searchValues, setSearchValues] = useState({});
  // const timeoutRef = useRef(null);
  const handleInputChange = (fomular_alias, value) => {
    setSearchValues((prevValues) => {
      if (value.trim() === "") {
        const { [fomular_alias]: _, ...newValues } = prevValues;
        return newValues;
      } else {
        return {
          ...prevValues,
          [fomular_alias]: value,
        };
      }
    });
  };

  useEffect(() => {
    if (currentPage >= 1) {
      setRequireCount(false);
    }
    // ////////console.log(requireCount)
  }, [currentPage]);

  // ////////console.log(2343243243324242, currentPage - 1)
  const [previousSearchValues, setPreviousSearchValues] = useState({});
  const [currentCount, setCurrentCount] = useState(null);

  const callApi = (data, dataUrl, startIndex = currentPage - 1) => {
    const startTime = new Date().getTime();
    let loadingTimeout;
    let loadingTimeoutSearch;

    loadingTimeout = setTimeout(() => {
      setLoading(true);
    }, 300);
    const getApi = functions.findGetApi(page);
    ////////console.log(482, getApi)
    const searchBody = {
      // table_id: dataTable_id,
      start_index: startIndex,
      criteria: data,
      require_count: false,
      require_statistic: false,
      // api_id: getApi?.split('/')[2]
      // exact: true
    };

    //////console.log("ĐÂY LÀ BODY:", searchBody)

    if (dataUrl) {
      fetch(`${proxy()}${dataUrl}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: _token,
          fromIndex: currentPage - 1,
        },
        body: JSON.stringify(searchBody),
      })
        .then((res) => res.json())
        .then((res) => {
          const {
            success,
            content,
            data,
            result,
            total,
            fields,
            count,
            sumerize,
          } = res;
          const statisticValues = res.statistic;
          //////console.log(74, res)
          if (success) {
            setApiData(data.filter((record) => record != undefined));

            setDataStatis(statisticValues);
            setLoaded(true);

            if (data.length < 15) {
              setTotalPages(currentPage);
            } else if (currentPage === totalPages) {
              setTotalPages((prevTotalPages) => prevTotalPages + 1);
            }
          } else {
            setApiData([]);
            setApiDataName([]);
          }

          const endTime = new Date().getTime();
          const elapsedTime = endTime - startTime;

          clearTimeout(loadingTimeout);
          clearTimeout(loadingTimeoutSearch); // Clear the timeout
          setLoadingSearch(false);
          setLoading(false);
          // ////////console.log(`---------------------------------TimeResponse: ${elapsedTime} ms`);
        });
    }
  };

  const callApiCount = (requireCount = false) => {
    const startTime = new Date().getTime();
    let loadingTimeout;
    let loadingTimeoutSearch;
    loadingTimeout = setTimeout(() => {
      // setLoading(true)
      setLoadingResult(true);
    }, 300);

    if (JSON.stringify(searchValues) !== JSON.stringify(previousSearchValues)) {
      setPreviousSearchValues(searchValues);
      requireCount = true;
    }
    const getApi = functions.findGetApi(page);

    const searchBody = {
      table_id: dataTable_id,
      start_index: currentPage - 1,
      criteria: searchValues,
      require_count: true,
      require_statistic: false,
      api_id: getApi?.split("/")[2],
      // exact: true
    };

    // ////////console.log(searchBody)

    fetch(`${proxy()}${functions.findSearchApi(page)}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
        fromIndex: currentPage - 1,
      },
      body: JSON.stringify(searchBody),
    })
      .then((res) => res.json())
      .then((res) => {
        const {
          success,
          content,
          data,
          result,
          total,
          fields,
          count,
          sumerize,
        } = res;
        const statisticValues = res.statistic;
        // ////////console.log(74, res)
        if (success) {
          if (count !== undefined && requireCount) {
            setCurrentCount(count);
            setSumerize(count);
          } else if (sumerize !== undefined) {
            setSumerize(sumerize);
          } else if (!requireCount && currentCount != null) {
            setSumerize(currentCount);
          }
        } else {
          setApiData([]);
          setApiDataName([]);
        }

        const endTime = new Date().getTime();
        const elapsedTime = endTime - startTime;

        clearTimeout(loadingTimeout);
        clearTimeout(loadingTimeoutSearch); // Clear the timeout
        setLoadingResult(false);
        // setLoadingSearch(false);
        // setLoading(false)
        // ////////console.log(`---------------------------------TimeResponse: ${elapsedTime} ms`);
      });
  };
  const callApiStatistic = (requireCount = false) => {
    const startTime = new Date().getTime();
    let loadingTimeout;
    let loadingTimeoutSearch;
    loadingTimeout = setTimeout(() => {
      // setLoading(true)
      setLoadingResult(true);
    }, 300);

    if (JSON.stringify(searchValues) !== JSON.stringify(previousSearchValues)) {
      setPreviousSearchValues(searchValues);
      requireCount = true;
    }
    const getApi = functions.findGetApi(page);
    const searchBody = {
      table_id: dataTable_id,
      start_index: currentPage - 1,
      criteria: searchValues,
      require_count: false,
      require_statistic: true,
      api_id: getApi?.split("/")[2],
      // exact: true
    };

    ////////console.log(searchBody)

    fetch(`${proxy()}${functions.findSearchApi(page)}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
        fromIndex: currentPage - 1,
      },
      body: JSON.stringify(searchBody),
    })
      .then((res) => res.json())
      .then((res) => {
        const {
          success,
          content,
          data,
          result,
          total,
          fields,
          count,
          sumerize,
        } = res;
        const statisticValues = res.statistic;
        ////////console.log(74, res)
        if (success) {
          if (count !== undefined && requireCount) {
            setCurrentCount(count);
            setSumerize(count);
          } else if (sumerize !== undefined) {
            setSumerize(sumerize);
          } else if (!requireCount && currentCount != null) {
            setSumerize(currentCount);
          }
        } else {
          setApiData([]);
          setApiDataName([]);
        }

        const endTime = new Date().getTime();
        const elapsedTime = endTime - startTime;

        clearTimeout(loadingTimeout);
        clearTimeout(loadingTimeoutSearch); // Clear the timeout
        setLoadingResult(false);
        // setLoadingSearch(false);
        // setLoading(false)
        // ////////console.log(`---------------------------------TimeResponse: ${elapsedTime} ms`);
      });
  };

  useEffect(() => {
    // callApiView()
    if (page) {
      // callApiView();
    }
  }, [page, dataTable_id]);

  //searching
  useEffect(() => {
    let timeout;
    if (loadingSearch) {
      Swal.fire({
        title: lang["searching"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      timeout = setTimeout(() => {
        Swal.close();
      }, 10);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [loadingSearch]);

  ///Loading
  useEffect(() => {
    let timeout;
    if (!loadingSearch && loading) {
      Swal.fire({
        title: lang["loading"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      timeout = setTimeout(() => {
        Swal.close();
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [loading]);

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      handleSearchClick();
    }
  };

  const handleSearchClick = (data) => {
    setSearchValues(data);
    ////////console.log(762, data)
    setCurrentPage(1);
    if (currentPage === 1) {
      callApiCount();
      callApi(data);
      callApiStatistic();

      setSumerize(0);
    }
  };
  ////////console.log(775, searchValues)

  const redirectToInput = (props, apiId, setRefreshPage) => {
    const { buttons } = props;
    const { add } = buttons;
    const page = findPageById(pages, `${isPageId}`);

    setIsData({ isUrl: apiId, setRefreshPage, pageId: page?.page_id });
    setAnotherModal(true);

    if (add.isPopup !== true) {
      // navigate(`/${url ? url : isPageId}/create`);
      navigate(`/${url ? url : isPageId}/add/${apiId}`);
    } else {
      setModal(false);
      setModalAdd(true);
    }
  };

  const redirectToImportData = (id) => {
    window.location.href = `/${url}/import/${id}`;
  };
  const handleViewDetail = async (record, dataUrl, props) => {
    const { buttons } = props;
    const { detail } = buttons;
    const { isPopup } = detail;
    const api_detail = functions.findDetailApi(page);
    if (isPopup) {
      setModal(false);
    }

    if (api_detail != undefined) {
      const id_str = dataUrl.split("/")[2];

      const response = await new Promise((resolve, reject) => {
        fetch(`${proxy()}/apis/api/${id_str}/input_info`, {
          headers: {
            Authorization: _token,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { data, success, content } = res;
            if (success) {
              // ////////console.log("succcess", data)
              setDataTables(data.tables);
              setDataFields(data.body);
            }
            resolve(res);
          });
      });
      const { success, data } = response;
      if (success) {
        const { params } = data;
        const stringifiedParams = params
          .map((param) => {
            const { fomular_alias } = param;
            return record[fomular_alias];
          })
          .join("/");
        setIsData({
          urlData: `/${url}/detail/${id_str}/${stringifiedParams}`,
          isModal,
          idStr: id_str,
        });
        if (detail.isPopup !== true) {
          setModal(false);
          openTab(`/${url}/detail/${id_str}/${stringifiedParams}`);
        }
      }
    } else {
      Swal.fire({
        title: lang["faild"],
        text: lang["not found"],
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleTable_Param = async (record, dataUrl) => {
    ////console.log(dataUrl)
    const api_detail = functions.findDetailApi(page);
    if (api_detail != undefined) {
      const id_str = dataUrl.split("/")[2];

      const response = await new Promise((resolve, reject) => {
        fetch(`${proxy()}/apis/api/${id_str}/input_info`, {
          headers: {
            Authorization: _token,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { data, success, content } = res;
            if (success) {
              // ////////console.log("succcess", data)
              setDataTables(data.tables);
              setDataFields(data.body);
            }
            resolve(res);
          });
      });
      const { success, data } = response;
      if (success) {
        const { params } = data;
        const stringifiedParams = params
          .map((param) => {
            const { fomular_alias } = param;
            return record[fomular_alias];
          })
          .join("/");

        openTab(`/${url}/detail/${id_str}/${stringifiedParams}`);
      }
    } else {
      Swal.fire({
        title: lang["faild"],
        text: lang["not found"],
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleRedirect = async (
    row,
    pageId,
    params,
    item,
    props,
    idModal,
    { buttonId = "" } = {}
  ) => {
    const { isPopup, popupStyles } = props;
    setPopupStyles(popupStyles);

    handleRefreshModal();
    if (isPopup) {
      setModal(true);
      setButtonId(buttonId);
    }

    let params_mapped = "";
    let params_search = "";
    let param = "";
    const page = findPageById(pages, `${pageId}`);

    if (page && page.component.length > 0) {
      setDataBtnLink(page?.component);
      setIdModal(idModal);
      setAnotherModal(true);
    }

    if (page?.old_url_format) {
      const fomularAlias = params.map((item) => item.fomular_alias);
      const values = fomularAlias.map((alias) => row[alias]);
      // setIsData({ page, values: `/${values.join("/")}` });
      setParam(values);
      setParamSearh(values);

      if (isPopup !== true) {
        // setModal(false);
        openTab(`/${pageId}/${values.join("/")}`);
        sessionStorage.setItem("oldUrl", window.location.pathname);
      }
    } else {
      params?.map(({ fomular_alias }) => {
        params_mapped += `${fomular_alias}=${row[fomular_alias]}&`;
        param += `${row[fomular_alias]}/`;
        params_search = row[fomular_alias];
      });

      if (param) {
        setParam(param);
      }
      params_mapped = "?" + params_mapped;
      params_mapped = params_mapped.slice(0, -1);
      setParamSearh(params_search);
      // setIsData({ page, paramMapped: params_mapped, pageId });
      // setRenderTable(true);
      if (isPopup !== true) {
        setModal(false);
        sessionStorage.setItem("oldUrl", window.location.pathname);
        sessionStorage.setItem("buttonId", buttonId);
        openTab(`/${pageId}${params_mapped}`);
      }
    }
  };
  const handleButtonLink = async (
    row,
    pageId,
    params,
    item,
    isPopup,
    props,
    idModal
  ) => {
    handleRefreshModal();

    let params_mapped = "";
    if (isPopup) {
      setModal(true);
    }

    const page = findPageById(pages, `${pageId}`);
    if (page && page.component.length > 0) {
      setDataBtnLink(page.component);
      setPageId(page.page_id);
      setIdModal(idModal);
    }

    if (page?.old_url_format) {
      const fomularAlias = params.map((item) => item.fomular_alias);
      const values = fomularAlias.map((alias) => row[alias]);

      if (isPopup !== true) {
        openTab(`/${pageId}/${values.join("/")}`);
      }
    } else {
      params?.map(({ fomular_alias }) => {
        params_mapped += `${fomular_alias}=${row[fomular_alias]}&`;
      });

      params_mapped = "?" + params_mapped;
      params_mapped = params_mapped.slice(0, -1);
      if (isPopup !== true) {
        setModal(false);
        openTab(`/${pageId}${params_mapped}`);
      }
    }
  };
  const handleRedirectTable = async (
    row,
    pageId,
    params,
    item,
    isPopup,
    popupStyles,
    idModal,
    dynamicModal,
    setDynamicModal
  ) => {
    handleRefreshModal();
    if (isPopup) {
      setModalTable(true);
    }
    let params_mapped = "";
    let param = "";
    const page = pages.find((page) => page.page_id === pageId);
    if (page && page.component.length > 0) {
      setDataTable(page.component);
      // setIdModal(idModal);
    }

    if (page?.old_url_format) {
      const fomularAlias = params.map((item) => item.fomular_alias);
      const values = fomularAlias.map((alias) => row[alias]);
      setParamTable(values.join("/"));
      setParamSearhTable(values.join("/"));
      params_mapped = values.join("/");
      param = values.join("/");
      // setIsData({ page, values: `/${values.join("/")}` });
      if (isPopup !== true) {
        openTab(`/${pageId}/${values.join("/")}`);
      }
    } else {
      params?.map(({ fomular_alias }) => {
        params_mapped += `${fomular_alias}=${row[fomular_alias]}&`;
        param += `${row[fomular_alias]}`;
      });

      params_mapped = "?" + params_mapped;
      params_mapped = params_mapped.slice(0, -1);
      setParamSearhTable(params_mapped);

      setParamTable(param);
      if (isPopup !== true) {
        setModal(false);
        openTab(`/${pageId}${params_mapped}`);
      }
    }
    setDynamicModals((prev) => [
      ...prev,
      {
        id: pageId,
        dataTable: page.component,
        isParamTable: param,
        paramSearchTable: params_mapped,
        popupStyles,
      },
    ]);
  };

  const deleteData = (data) => {
    let rawParams = page.apis.delete;
    // const keys = Object.keys(data);
    // keys.map(key => {
    //     const value = data[key];
    //     rawParams = rawParams.replaceAll(key, value);
    // })

    fetch(`${proxy()}${rawParams}`, {
      method: "DELETE",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, content } = res;
        if (success) {
          // al.success("Thành công", "Xóa dữ liệu thành công")
          setTimeout(() => {
            window.location.reload();
          }, 1600);
        } else {
          // al.failure("Thất bại", "Xóa thất bại")
        }
      });
  };
  ////////console.log(838, functions.findDeleteApi(page))

  const handleDelete = (data, setRefreshPage, props) => {
    const {
      textConfirm,
      message,
      conditionDelete,
      api: { url: dataUrl },
    } = props;
    if (typeof data === "object" || data !== undefined) {
      let extractedValues = functions.extractValuesFromData(
        functions.findComponentWithDeleteApiUrl(page, dataUrl),
        data
      );
      let api_delete = dataUrl;
      extractedValues = String(extractedValues).replace(/\//g, ",");

      const newParams = `${api_delete}/${extractedValues}`;
      ////////console.log(newParams)
      Swal.fire({
        title: lang["confirm"],
        text: textConfirm ? textConfirm : lang["confirm.content"],
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: lang["btn.delete"],
        cancelButtonText: lang["btn.cancel"],
        confirmButtonColor: "rgb(209, 72, 81)",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: lang["processing"] || "Đang xóa dữ liệu...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          // const newParams = functions.findDeleteApi(page)
          fetch(`${proxy()}${newParams}`, {
            method: "DELETE",
            headers: {
              "content-type": "application/json",
              Authorization: `${_token}`,
            },
            body: JSON.stringify({ position: data.position }),
          })
            .then((res) => res.json())
            .then((resp) => {
              const { success, content, status } = resp;
              ////////console.log(resp)
              // functions.showApiResponseMessage(status)
              if (success) {
                Swal.fire({
                  title: lang["success"],
                  text: lang["success.delete"],
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  setRefreshPage((prev) => prev + 1);
                });
              } else {
                if (resp.content == "403 - Forbidden") {
                  Swal.fire({
                    title: lang["fail"],
                    text: lang["no privileges"],
                    icon: "error",
                    showConfirmButton: true,
                    // timer: 1500,
                  });
                } else if (
                  resp?.errors?.description === "Foreign key violation"
                ) {
                  let shouldShowAlert = false;
                  let messageContent = "";
                  const swalMess = `<span>${lang["Foreign key violation"]
                    }:</span>
                  <br>
                  <span><strong>${resp?.errors?.tables
                      ?.map((item) => item.table_name)
                      .join("<br>")}</strong></span>`;
                  for (const cond in conditionDelete) {
                    const item = conditionDelete[cond];

                    if (
                      data?.[item?.value] &&
                      data?.[item?.value] !== item?.condition
                    ) {
                      shouldShowAlert = true;
                      messageContent += item?.message
                        ? `<span>${item?.message}</span><br>`
                        : `<span>${lang["Foreign key violation"]
                        }:</span><br><span><strong>${resp?.errors?.tables
                          ?.map((item) => item.table_name)
                          .join("<br>")}</strong></span><br>`;
                      break;
                      // Swal.fire({
                      //   title: lang["fail"],
                      //   html: item?.message
                      //     ? ` <span>${item?.message}</span>`
                      //     : swalMess,
                      //   icon: "error",
                      //   showConfirmButton: true,
                      // });
                    }
                  }
                  if (shouldShowAlert) {
                    Swal.fire({
                      title: lang["fail"],
                      html: messageContent,
                      icon: "error",
                      showConfirmButton: true,
                    });
                  } else {
                    Swal.fire({
                      title: lang["fail"],
                      html: swalMess,
                      icon: "error",
                      showConfirmButton: true,
                    });
                  }

                  // Swal.fire({
                  //   title: lang["fail"],
                  //   html: message
                  //     ? ` <span>${message}</span>`
                  //     : `
                  //     <span>${lang["Foreign key violation"]}:</span>
                  //     <span><strong>${resp?.errors?.tables
                  //       ?.map((item) => item.table_name)
                  //       .join("<br>")}</strong></span>
                  //   `,
                  //   icon: "error",
                  //   showConfirmButton: true,
                  // });
                } else {
                  Swal.fire({
                    title: lang["faild"],
                    text: message ? message : lang["fail.delete"],
                    icon: "error",
                    showConfirmButton: true,
                    // timer: 2000,
                  });
                }
              }
            });
        }
      });
    }
  };

  const redirectToInputPUT = async (record, props, dataUrl, setRefreshPage) => {
    const { buttons } = props;
    const { update } = buttons;
    const dataApiPut = functions.findPutApi(page);
    const findPage = findPageById(pages, `${isPageId}`);
    if (update.isPopup) {
      setModal(true);
    } else {
      setModal(false);
    }
    if (dataApiPut != undefined) {
      const id_str = dataUrl.split("/")[2];
      const response = await new Promise((resolve, reject) => {
        fetch(`${proxy()}/apis/api/${id_str}/input_info`, {
          headers: {
            Authorization: _token,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { data, success, content } = res;
            ////////console.log(res)
            if (success) {
              setDataTables(data.tables);
              setDataFields(data.body);
            }
            resolve(res);
          });
      });
      const { success, data } = response;
      ////////console.log(54, response)
      if (success) {
        const { params } = data;

        const stringifiedParams = params
          .map((param) => {
            const { fomular_alias } = param;
            return record[fomular_alias];
          })
          .join("/");
        setIsData({
          urlData: `/${url}/update/${id_str}/${stringifiedParams}`,
          id_str,
          stringifiedParams,
          isModal: update.isPopup,
          setRefreshPage,
          pageId: findPage?.page_id,
        });
        setAnotherModal(true);
        ////////console.log(962, stringifiedParams)
        // console.log("EDIT",id_str,stringifiedParams,data,record)
        if (update.isPopup !== true) {
          navigate(
            `/${url ? url : isPageId}/update/${id_str}/${stringifiedParams}`
          );
        }
      }
    } else {
      Swal.fire({
        title: lang["faild"],
        text: lang["not found update"],
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const renderBoolData = (data, field) => {
    const IF_TRUE = field.DEFAULT_TRUE;
    const IF_FALSE = field.DEFAULT_FALSE;
    if (data != undefined) {
      if (data) {
        return IF_TRUE ? IF_TRUE : "true";
      }
      return IF_FALSE ? IF_FALSE : "false";
    } else {
      return IF_FALSE ? IF_FALSE : "false";
    }
  };
  const formatIfDate = (value) => {
    // Kiểm tra xem giá trị có phải là chuỗi ngày giờ ISO không
    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
      // Định dạng ngày giờ theo yêu cầu của bạn (ví dụ: dd/mm/yyyy)
      const date = new Date(value);
      return date.toLocaleDateString("vi-VN");
    }
    return value; // Nếu không phải ngày, trả về giá trị như cũ
  };
  const renderData = (field, data) => {
    if (data) {
      switch (field.DATATYPE) {
        case "DATE":
        case "DATETIME":
          return renderDateTimeByFormat(
            data[field.fomular_alias],
            field.FORMAT
          );
        case "DECIMAL":
        case "DECIMAL UNSIGNED":
          const { DECIMAL_PLACE } = field;
          const decimalNumber = parseFloat(data[field.fomular_alias]);
          return decimalNumber.toFixed(DECIMAL_PLACE);
        case "BOOL":
          return renderBoolData(data[field.fomular_alias], field);
        default:
          return data[field.fomular_alias];
      }
    } else {
      return "Invalid value";
    }
  };

  // Sử dụng hàm
  const callApiView = (startAt = 0, amount = rowsPerPage) => {
    const headerApi = {
      Authorization: _token,
      "start-at": startAt,
      "data-amount": amount,
    };
    const getApi = functions.findGetApi(page);

    if (getApi) {
      fetch(`${proxy()}${getApi}`, {
        headers: headerApi,
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, content, data, count, fields, limit, statistic } =
            res;
          ////////console.log(123456, res)
          setApiData([]);
          if (data && data.length > 0) {
            setApiData(data.filter((record) => record != undefined));
            // setApiDataName(fields);
            setDataStatis(statistic);
            setSumerize(count);
          }
        });
    } else {
      // console.error('Invalid API URL');
    }
  };

  const [totalPages, setTotalPages] = useState(0);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const current = apiData;
  //console.log(1175, current)
  const paginate = (pageNumber) => {
    const startAt = (pageNumber - 1) * rowsPerPage;
    if (Object.keys(searchValues).length === 0) {
      callApiView(startAt, rowsPerPage);
    } else {
      callApi(pageNumber - 1);
    }
    setCurrentPage(pageNumber);
  };

  const accurateTotalPages = Math.ceil(sumerize / rowsPerPage) || totalPages;
  if (totalPages !== accurateTotalPages) {
    setTotalPages(accurateTotalPages);
  }
  const [selectedFields, setSelectedFields] = useState([]); /// fields
  const [selectedStats, setSelectedStats] = useState([]);
  const [exportType, setExportType] = useState("excel");
  const [selectedConditionField, setSelectedConditionField] = useState({});
  const [selectedUniqueField, setSelectedUniqueField] = useState({});
  // statis fields
  const handleStatsChange = (event) => {
    const { value } = event.target;
    setSelectedStats((prevStats) =>
      prevStats.includes(value)
        ? prevStats.filter((stat) => stat !== value)
        : [...prevStats, value]
    );
  };

  //fields
  const [selectAll, setSelectAll] = useState(true);
  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedFields([]);
    } else {
      setSelectedFields(apiDataName?.map((header) => header.fomular_alias));
    }
    setSelectAll(!selectAll);
  };

  const handleFieldChange = (event) => {
    const { value } = event.target;
    setSelectedFields((prevFields) =>
      prevFields.includes(value)
        ? prevFields.filter((field) => field !== value)
        : [...prevFields, value]
    );
  };

  const handleSelectedField = (value, checked = false, cb, getID) => {
    cb((prev) => {
      const newPrev = { ...prev };

      if (!getID || getID == undefined) {
        return prev;
      }

      if (!newPrev[getID]) {
        newPrev[getID] = {};
      }
      newPrev[getID][value] = checked;
      return newPrev;
    });
  };
  const handleSelectedFieldTID = (value, checked = false, cb) => {
    cb((prev) => ({ ...prev, [value]: checked }));
  };

  function jsonToCsv(jsonData) {
    const header = Object.keys(jsonData[0]).join(",");
    const rows = jsonData.map((row) => Object.values(row).join(","));
    return [header, ...rows].join("\n");
  }

  const exportToCSV = async (csvData, fields) => {
    //////console.log(fields)
    const selectedHeaders = fields;
    const { makeAutoIncreament } = functions;
    function styleHeaders(ws) {
      const headerStyle = {
        fill: {
          fgColor: { rgb: "008000" },
        },
        font: {
          bold: true,
          color: { rgb: "fffffff" },
        },
      };

      const colNum = XLSX.utils.decode_range(ws["!ref"]).e.c + 1;
      for (let i = 0; i < colNum; ++i) {
        const cellRef = XLSX.utils.encode_cell({ c: i, r: 0 });
        if (ws[cellRef]) {
          ws[cellRef].s = headerStyle;
        }
      }
    }
    const generateSampleData = (field) => {
      switch (field.DATATYPE) {
        case "INT":
          return "0001";
        case "INT UNSIGNED":
          return "0001";
        case "BIGINT":
          return "0001";
        case "BIGINT UNSIGNED":
          return "0001";
        case "TEXT":
          return "Sample Text";
        case "BOOL":
          return "True/False";
        case "DECIMAL":
          return "1.00";
        case "DECIMAL":
          return "1.0";
        case "CHAR":
          return "a";
        case "EMAIL":
          return "abc@gmail.com";
        case "PHONE":
          return "0123456789";
        case "DATE":
          return "01/11/2022";
        case "DATETIME":
          return "01/11/2022 10:10:26";
        default:
          return "Sample Text";
      }
    };
    // const headerRow = selectedHeaders.reduce((obj, header) => ({ ...obj, [header.fomular_alias]: header.display_name }), {});

    const segments = page.page_title;

    // const lastSegment = segments[segments.length - 1];//tên

    const result = segments;

    const headerRow = selectedHeaders.map(
      (header) => `${header.field_name}(${header.fomular_alias})`
    );

    // const sampleRow = selectedHeaders.map((header) =>
    //   generateSampleData(header)
    // );
    const sampleRow = await Promise.all(
      selectedHeaders.map((header) => {
        if (header.PATTERN || header.FORMAT) {
          return makeAutoIncreament(
            header.FORMAT ? header.FORMAT : null,
            header.PATTERN ? header.PATTERN : header.FORMAT
          );
        } else {
          return generateSampleData(header);
        }
      })
    );

    if (csvData === "xlsx") {
      const ws = XLSX.utils.json_to_sheet([headerRow, sampleRow], {
        skipHeader: true,
      });
      styleHeaders(ws);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Template");

      XLSX.writeFile(
        wb,
        `TEMPLATE_EXCEL_${result.toUpperCase()}_${new Date().getTime()}.xlsx`
      );
    } else if (csvData === "csv") {
      const utf8BOM = "\uFEFF";

      const csv =
        utf8BOM + headerRow.join(",") + "\n" + sampleRow.join(",") + "\n";

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");

      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);

      link.setAttribute(
        "download",
        `TEMPLATE_CSV_${result.toUpperCase()}_${new Date().getTime()}.csv`
      );

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    }
    $("#closeModalExportFileSample").click();
  };

  const filterSelectedField = (obj, state = true) => {
    const selectedObject = {};
    for (const k in obj) {
      if (obj[k] === true) {
        selectedObject[k] = true;
      }
    }
    return selectedObject;
  };

  const getCurrentDateTimeForFilename = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  };
  useEffect(() => {
    if (loadingExportFile == true) {
      Swal.fire({
        title: lang["success.export"],
        icon: "success",
        timer: 2500,
      });
    }
  }, [loadingExportFile]);

  const Export = (payload) => {
    const mappedSelectedFields = selectedFields.map((fomular_alias) => {
      const field = apiDataName.find(
        (field) => field.fomular_alias === fomular_alias
      );

      return field?.field_name || fomular_alias;
    });
    const selectFields = [...selectedFields, ...selectedStats];

    const exportBody = {
      export_fields: selectFields,
      header_fields: [...mappedSelectedFields, ...selectedStats],
      criteria: valueExport,
      export_type: exportType,
      condition_fields: selectedConditionField,
      unique_fields: selectedUniqueField,
      export_excel_type,
      ...payload,
      isExportBtn: isExportBtn,
    };

    if (loadingExportFile == false) {
      Swal.fire({
        title: lang["loading"],
        allowEscapeKey: false,
        allowOutsideClick: false,

        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    //STREAMING
    fetch(`${proxy()}${dataUrlExport}/?cpn_id=${getCpnId}`, {
      method: "POST",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      body: JSON.stringify(exportBody),
    })
      .then((response) => response.body)
      .then((rb) => {
        const reader = rb.getReader();

        return new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value);
                push();
              });
            }

            push();
          },
        });
      })
      .then((stream) =>
        new Response(stream, {
          headers: { "content-type": "application/json" },
        }).blob()
      )
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        const datetimeString = getCurrentDateTimeForFilename();

        const segments = page.page_title.split("/");
        const lastSegment = segments[segments.length - 1]; //tên
        const result = lastSegment.replace(/-/g, "");
        const criteriaContent = Object.values(exportBody.criteria);

        a.download =
          exportType === "excel"
            ? `DATA_${result.toUpperCase()}_${datetimeString}_${criteriaContent}.xlsx`
            : `DATA_${result.toUpperCase()}_${datetimeString}_${criteriaContent}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoadingExportFile(true);
      })
      .catch((error) => {
        console.error("Error during export:", error);
        setLoadingExportFile(false);
      });

    // fetch(`${proxy()}${dataUrlExport}`, {
    //   method: "POST",
    //   headers: {
    //     "content-type": "application/json",
    //     Accept:
    //       exportType === "excel"
    //         ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    //         : "text/csv",
    //   },
    //   body: JSON.stringify(exportBody),
    // })
    //   .then((res) => res.blob())

    //   .then((blob) => {
    //     if (exportType === "csv") {
    //       const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    //       const withBom = new Blob([bom, blob], { type: "text/csv" });
    //       blob = withBom;
    //     }
    //     const url = window.URL.createObjectURL(blob);
    //     ////////console.log(1300, url)
    //     const a = document.createElement("a");
    //     a.style.display = "none";
    //     a.href = url;

    //     const datetimeString = getCurrentDateTimeForFilename();

    //     const segments = page.page_title.split("/");
    //     const lastSegment = segments[segments.length - 1]; //tên
    //     const result = lastSegment.replace(/-/g, "");
    //     const criteriaContent = Object.values(exportBody.criteria);

    //     a.download =
    //       exportType === "excel"
    //         ? `DATA_${result.toUpperCase()}_${datetimeString}_${criteriaContent}.xlsx`
    //         : `DATA_${result.toUpperCase()}_${datetimeString}_${criteriaContent}.csv`;

    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    //     setLoadingExportFile(false);
    //     setSelectedFields([]);
    //     setSelectAll(false);
    //   })
    //   .catch((error) => {
    //     console.error("Error during export:", error);
    //     setLoadingExportFile(false);
    //   });
  };

  const callApiDataModalExport = (
    cpn_id,
    url,
    type,
    paramExport,
    startAt = 0,
    amount = 15
  ) => {
    fetch(`${proxy()}${url}${type ? paramExport : ""}/?cpn_id=${cpn_id}`, {
      headers: {
        Authorization: _token,
        "data-amount": amount,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data, count } = res;
        if (data && data.length > 0) {
          setApiData(data.filter((record) => record != undefined));
          setCountData(count);
          setSumerize(count);
        }
      });
  };

  const callApiDataModalExport_PK = (
    data,
    dataUrl,
    startIndex = currentPage - 1
  ) => {
    const searchBody = {
      start_index: startIndex,
      criteria: data,
      require_count: false,
      require_statistic: false,
    };

    if (dataUrl) {
      fetch(`${proxy()}${dataUrl}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: _token,
          fromIndex: currentPage - 1,
          "data-amount": rowsPerPage,
        },
        body: JSON.stringify(searchBody),
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, data } = res;

          if (success) {
            setApiData(data.filter((record) => record != undefined));
          } else {
          }
        });
    }
  };

  const exportFile = (
    dataField,
    dataUrlGet,
    dataUrl,
    export_excel_type,
    props,
    type,
    paramExport,
    cpn_id
  ) => {
    setCpnId(cpn_id);
    if (export_excel_type === "statistic") {
      setAnotherModal(true);
      const {
        joiningTable,
        joiningTables,
        source: { calculates, DisplayFields },
        filteringFields = [],
        export: {
          api: { url },
        },
      } = props;

      const fields = [];
      const MAPPED_FIELDS = {};

      for (const index in database?.fields) {
        const { fomular_alias, props, field_name, table_id } =
          database.fields[index];
        MAPPED_FIELDS[fomular_alias] = {
          ...props,
          props,
          field_name,
          table_id,
          fomular_alias,
        };
      }

      for (const index in filteringFields) {
        const { field, name } = filteringFields[index];

        fields.push({
          field_name: name,
          fomular_alias: field,
          isFiltering: true,
          type: MAPPED_FIELDS[field.split(",").at(-1).split(".").at(-1)],
          value: [
            field.split(",").map((item) => ({ label: item, value: name }))[0],
          ],
          array: field.split(",").map((item) => ({ label: item, value: name })),
        });
      }

      for (const index in DisplayFields) {
        const { label, value, exported_fields } = DisplayFields[index];
        const field = {
          field_name: label,
          fomular_alias: value?.[0].value,
        };
        if (exported_fields?.length) {
          field.fomular_alias = exported_fields[0].value;
        }
        fields.push(field);
      }

      // for (const k in joiningTable.select_root) {
      //   fields.push({
      //     field_name: k,
      //     fomular_alias: k,
      //   });
      // }

      // for (const index in joiningTables) {
      //   const { select_root } = joiningTables[index];
      //   for (const k in select_root) {
      //     fields.push({
      //       field_name: k,
      //       fomular_alias: k,
      //     });
      //   }
      // }

      // for (const index in calculates) {
      //   const { fomular_alias, display_name } = calculates[index];
      //   fields.push({
      //     field_name: display_name,
      //     fomular_alias: fomular_alias,
      //   });
      // }

      setApiDataName(fields);
      setSelectedFields(
        fields.filter((f) => !f?.isFiltering).map((f) => f.fomular_alias)
      );
      setDataUrlExport(url);
    } else {
      const { FIELDS } = props;

      const fieldMap = new Map(
        FIELDS.map((f) => [f.fomular_alias, f])
      );

      const mapped = dataField.map((item) => {
        const field = fieldMap.get(item?.value?.[0]?.label?.split('$')[1]);

        if (!field) return item;

        return {
          ...item,
          type: {
            DATATYPE: field.DATATYPE
          }
        };
      });

      setApiDataName(mapped);
      setIsExportBtn(false);
      setDataUrlExport(dataUrl);
      setSelectedFields(dataField.map((f) => f.fomular_alias));
      setLoadingExportFile(false);
      setExportedData();
      setAnotherModal(true);
    }
    setExport_excel_type({
      export_excel_type,
      props,
    });
    callApiDataModalExport(cpn_id, dataUrlGet, type, paramExport);
  };

  const exportFile_PK = (
    dataField,
    dataUrlPreview,
    dataUrl,
    fomularAlias_PK,
    data,
    fields
  ) => {
    setAnotherModal(true);
    setApiDataName(fields);
    setDataUrlExport(dataUrl);
    setSelectedFields(fields.map((f) => f.fomular_alias));
    setIsExportBtn(true);
    const extractValueByKey = (data, key) => {
      return { [key]: data[key] };
    };
    // Sử dụng hàm
    const result = extractValueByKey(data, fomularAlias_PK);

    setaValueExport(result);
    callApiDataModalExport_PK(result, dataUrlPreview);
  };

  const submitButton_Custom = (
    params,
    url,
    condition_fields,
    fields,
    row,
    dataTableField,
    props,
    { refreshCustom }
  ) => {
    const mapped_params = [];

    for (const index in params) {
      const field = dataTableField.find((field) => field.id === params[index]);
      mapped_params.push(row[field.fomular_alias]);
    }
    const payload = { ...row };

    // for (const index in fields) {
    //   const field = fields[index];
    //   const mapped_field = dataTableField.find((f) => f.id === field.key);
    //   payload[mapped_field.fomular_alias] = field.value;
    // }
    callApiForButtonCustom(url, mapped_params, payload, refreshCustom);
  };

  const callApiForButtonCustom = (url, param, result, refreshCustom) => {
    Tables.update(url, param, result, proxy())
      .then((res) => res.json())
      .then((res) => {
        const {
          success,
          content,
          data,
          result,
          total,
          fields,
          count,
          sumerize,
        } = res;
        const statisticValues = res.statistic;
        //console.log(9999, res)
        if (success) {
          dispatch({
            branch: "ui",
            type: "checkState",
            payload: {
              success: true,
            },
          });
          Swal.fire({
            title: lang["success"],
            text: lang["success.update"],
            icon: "success",
            showConfirmButton: false,
            timer: 1800,
          }).then(() => refreshCustom((prev) => prev + 1));
        } else {
          Swal.fire({
            title: lang["error"],
            text: `Update failed`,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  const changeTrigger = (field, value) => {
    const newData = data;
    if (value === "true") {
      newData[field.fomular_alias] = true;
    } else if (value === "false") {
      newData[field.fomular_alias] = false;
    } else {
      newData[field.fomular_alias] = value;
    }
    setData(newData);
  };

  const [exportedData, setExportedData] = useState();
  const handleChangingExportedData = ({ key, value, array = [] }) => {
    if (key === "to") {
      setDataTo(value);
    }
    if (key === "from") {
      setDataFrom(value);
    }

    setExportedData((prev) => {
      const obj = { ...prev };

      array.forEach(({ label }) => {
        obj[label] = value;
      });

      const newKey = key.split(".")[1] || key;
      const field = database.fields.find(
        ({ fomular_alias }) => fomular_alias === newKey
      );

      if (newKey === "to" || newKey === "from") {
        obj[key] = Number(value);
      } else {
        if (field) {
          const table = database.tables.find(({ id }) => id === field.table_id);
          if (table) {
            const foreign = table.foreign_keys.find(
              ({ field_id }) => field_id === field.id
            );
            obj[key] = foreign ? String(value) : value;
          }
        }
      }

      return obj;
    });
  };

  const handleValidateIsNumber = (value, key) => {
    if (IsNumber(value) || value === "") {
      handleChangingExportedData({ key, value });
    }
  };

  const handleRefreshPage = () => {
    setRefreshPage((key) => key + 1);
  };

  const renderInputFilter = (data, item, array) => {
    let alias = item?.label?.split("-$")?.at(-1);

    switch (data?.type?.DATATYPE) {
      case "DATE":
        return (
          <section>
            <div className="input-search col-md-4 pl-0 d-flex align-items-center w-100">
              <label htmlFor={data.field_name}>Ngày bắt đầu</label>
              <span>
                <input
                  type="date"
                  className="form-control"
                  placeholder={data.field_name}
                  name={data.field_name}
                  onChange={({ target: { value } }) => {
                    handleChangingExportedData({
                      key: alias,
                      value: { ...(exportedData?.[alias] || {}), from: value },
                      array,
                    });
                  }}
                />
              </span>
            </div>
            <div className="input-search col-md-4 pl-0 d-flex align-items-center">
              <label htmlFor={data.field_name}>Ngày kết thúc</label>
              <span>
                <input
                  type="date"
                  className="form-control"
                  placeholder={data.field_name}
                  name={data.field_name}
                  onChange={({ target: { value } }) => {
                    handleChangingExportedData({
                      key: alias,
                      value: { ...(exportedData?.[alias] || {}), to: value },
                      array,
                    });
                  }}
                />
              </span>
            </div>
          </section>
        );
      case "DATETIME":
        return (
          <section>
            <div className="input-search col-md-4 pl-0 d-flex align-items-center w-100">
              <label htmlFor={data.field_name}>Ngày bắt đầu</label>
              <span>
                <input
                  type="date"
                  className="form-control"
                  placeholder={data.field_name}
                  name={data.field_name}
                  onChange={({ target: { value } }) => {
                    handleChangingExportedData({
                      key: alias,
                      value: { ...(exportedData?.[alias] || {}), from: value },
                      array,
                    });
                  }}
                />
              </span>
            </div>
            <div className="input-search col-md-4 pl-0 d-flex align-items-center">
              <label htmlFor={data.field_name}>Ngày kết thúc</label>
              <span>
                <input
                  type="date"
                  className="form-control"
                  placeholder={data.field_name}
                  name={data.field_name}
                  onChange={({ target: { value } }) => {
                    handleChangingExportedData({
                      key: alias,
                      value: { ...(exportedData?.[alias] || {}), to: value },
                      array,
                    });
                  }}
                />
              </span>
            </div>
          </section>
        );
      case "INT UNSIGNED":
        return (
          <input
            className="form-control filter"
            type="text"
            placeholder={data.field_name}
            onChange={({ target: { value } }) => {
              handleChangingExportedData({
                key: alias,
                value,
                array,
              });
            }}
          // style={{ width: "60%" }}
          />
        );
      default:
        return (
          <input
            className="form-control filter"
            type="text"
            placeholder={data.field_name}
            onChange={({ target: { value } }) => {
              handleChangingExportedData({
                key: alias,
                value,
                array,
              });
            }}
          // style={{ width: "60%" }}
          />
        );
    }
  };
  console.log("dynamicModals", dynamicModals);
  return (
    <div class="midde_cont">
      <div class="container-fluid">
        <div class="row">
          <div
            class={`modal `}
            id="exportExcel"
            style={{
              zIndex: 99999,
            }}
          >
            <div class="modal-dialog modal-dialog-center">
              <div
                class="modal-content"
                style={{
                  maxHeight: "82vh",
                  overflowY: "auto",
                  overflowX: "unset",
                }}
              >
                <div class="modal-header">
                  <h4 class="modal-title">{lang["export"]}</h4>
                  <button
                    type="button"
                    class="close"
                    onClick={handleCloseModal}
                    data-dismiss="modal"
                  >
                    &times;
                  </button>
                </div>
                <div class="modal-body export" style={{ overflow: "auto" }}>
                  <>
                    <section>
                      {/* thinh chinh sua chon hang de xuat, them tu vao ngon ngu va hien ra */}
                      <div
                        className="d-flex"
                        style={{
                          gap: "5px",
                          flexDirection: "column",
                        }}
                      >
                        <h5 class="mt-2 mb-2">{lang["select_export_rows"]}:</h5>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className="form-group m-1"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <label>{lang["from"]}:</label>
                            <input
                              className="form-control "
                              type="text"
                              placeholder={0}
                              value={exportedData?.["from"] || ""}
                              onChange={({ target: { value } }) => {
                                handleValidateIsNumber(value, "from");
                              }}
                            />
                          </div>
                          <div
                            className="form-group ml-5 m-1"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginLeft: "50px",
                            }}
                          >
                            <label>{lang["to"]}:</label>
                            <input
                              className="form-control "
                              type="text"
                              placeholder={0}
                              value={exportedData?.["to"] || ""}
                              onChange={({ target: { value } }) => {
                                handleValidateIsNumber(value, "to");
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                  <form>
                    {/* thinh chinh sua la cac phan tu trong truong( sap xep vi tri lai) */}
                    <h5 class="mt-2 mb-2">{lang["select fields"]}:</h5>
                    <div
                      className="select-all-checkbox"
                      style={{
                        maxWidth: "240px",
                        maxHeight: "40px",
                        margin: "15px 0px",
                      }}
                    >
                      <label style={{ display: "flex" }}>
                        {/* <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAllChange}
                        /> */}
                        {/* thinh thay check box lấy từ MUI(Material UI) */}
                        <Checkbox
                          sx={{
                            "&:hover": { bgcolor: "transparent" },
                            margin: 0,
                            padding: 0,
                          }}
                          checked={selectAll}
                          onChange={handleSelectAllChange}
                        />
                        {/* thinh dang sua ne  */}
                        {/* <label className="custom-checkbox">
                          <input type="checkbox" checked={selectAll}
                          onChange={handleSelectAllChange} />
                          <span className="checkmark"></span>
                          {label}
                        </label> */}

                        <span className="ml-2 font-weight-bold">
                          {lang["selectall"]}
                        </span>
                      </label>
                    </div>
                    <>
                      <div
                        className="table-responsive table-custom design-table"
                        style={{ height: "auto" }}
                      >
                        <table className="table">
                          <thead>
                            <tr>
                              <th className="header-filter">
                                {lang["field name"]}
                              </th>
                              <th className="header-filter">
                                {lang["select_export_condition"]}
                              </th>
                              <th
                                className="header-filter"
                                colSpan={2}
                                style={{
                                  display:
                                    export_excel_type.export_excel_type ===
                                      "statistic"
                                      ? "none"
                                      : "table-cell",
                                }}
                              >
                                {lang["conditions"]}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {apiDataName?.map((header, index) => {
                              let table = {
                                id: null,
                                primary_key: header.id,
                              };
                              const res = dataTables?.[0]?.foreign_keys.find(
                                (k) => k.field_id === header.id
                              );

                              if (res && table) {
                                table.id = res?.table_id;
                                table.primary_key = res.ref_field_id;
                              } else if (
                                dataTables?.[0]?.primary_key.includes(header.id)
                              ) {
                                table.id = header.table_id;
                              }
                              const BpIcon = styled("span")(({ theme }) => ({
                                borderRadius: 3,
                                width: 15,
                                height: 15,
                                boxShadow:
                                  theme.palette.mode === "dark"
                                    ? "0 0 0 1px rgb(16 22 26 / 40%)"
                                    : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? "#394b59"
                                    : "#f5f8fa",
                                backgroundImage:
                                  theme.palette.mode === "dark"
                                    ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
                                    : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
                                ".Mui-focusVisible &": {
                                  outline: "2px auto rgba(19,124,189,.6)",
                                  outlineOffset: 2,
                                },
                                "input:hover ~ &": {
                                  backgroundColor:
                                    theme.palette.mode === "dark"
                                      ? "#30404d"
                                      : "#ebf1f5",
                                },
                                "input:disabled ~ &": {
                                  boxShadow: "none",
                                  background:
                                    theme.palette.mode === "dark"
                                      ? "rgba(57,75,89,.5)"
                                      : "rgba(206,217,224,.5)",
                                },
                              }));

                              const BpCheckedIcon = styled(BpIcon)({
                                backgroundColor: "#008000",
                                backgroundImage:
                                  "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
                                "&::before": {
                                  display: "block",
                                  width: 15,
                                  height: 15,
                                  backgroundImage:
                                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                                    " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                                    "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
                                  content: '""',
                                },
                                "input:hover ~ &": {
                                  backgroundColor: "#008000",
                                },
                              });
                              return (
                                <tr key={index}>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      {!header?.isFiltering && (
                                        <Checkbox
                                          sx={{
                                            "&:hover": {
                                              bgcolor: "transparent",
                                            },
                                            margin: 0,
                                            padding: 0,
                                          }}
                                          value={header.fomular_alias}
                                          checked={selectedFields.includes(
                                            header.fomular_alias
                                          )}
                                          onChange={(e) => {
                                            handleFieldChange(e);
                                            handleSelectedField(
                                              header.fomular_alias,
                                              { checked: e.target.checked },
                                              setSelectedConditionField
                                            );
                                          }}
                                        />
                                      )}
                                      <span className="ml-2">
                                        {header?.display_name ||
                                          header?.field_name}
                                      </span>
                                    </div>
                                  </td>
                                  <td style={{ padding: "0.65rem" }}>
                                    {(selectedFields.includes(
                                      header.fomular_alias
                                    ) ||
                                      header?.isFiltering) &&
                                      header?.value?.[0] &&
                                      (() => {
                                        const item = header.value[0];
                                        const alias = item.label
                                          ?.split("-$")
                                          ?.at(-1)
                                          ?.split(".")
                                          ?.at(-1)
                                          ?.replace(/^\$/, "");

                                        return (
                                          <div key={`filter_${alias}`}>
                                            {table.id ? (
                                              <Option
                                                key={header.fomular_alias}
                                                label={header.field_name}
                                                table_id={table.id}
                                                primary_key={table.primary_key}
                                                onChange={(props) => {
                                                  handleChangingExportedData({
                                                    key: header.fomular_alias,
                                                    value: props.value,
                                                  });
                                                }}
                                              />
                                            ) : (
                                              <>
                                                {renderInputFilter(
                                                  header,
                                                  item,
                                                  header.array
                                                )}
                                              </>
                                            )}
                                          </div>
                                        );
                                      })()}
                                    {/* {(selectedFields.includes(
                                      header.fomular_alias
                                    ) ||
                                      header?.isFiltering) &&
                                      header?.value?.map((item) => {
                                        const alias = item.label
                                          ?.split("-$")
                                          ?.at(-1)
                                          ?.split(".")
                                          ?.at(-1)
                                          ?.replace(/^\$/, "");

                                        return (
                                          <div key={`filter_${alias}`}>
                                            {table.id ? (
                                              <Option
                                                key={header.fomular_alias}
                                                label={header.field_name}
                                                table_id={table.id}
                                                primary_key={table.primary_key}
                                                onChange={(props) => {
                                                  handleChangingExportedData({
                                                    key: header.fomular_alias,
                                                    value: props.value,
                                                  });
                                                }}
                                              />
                                            ) : (
                                              <>
                                                {renderInputFilter(
                                                  header,
                                                  item,
                                                  header.array
                                                )}
                                              </>
                                            )}
                                          </div>
                                        );
                                      })} */}
                                  </td>
                                  <td
                                    style={{
                                      display:
                                        export_excel_type.export_excel_type ===
                                          "statistic"
                                          ? "none"
                                          : "table-cell",
                                    }}
                                  >
                                    {selectedFields.includes(
                                      header.fomular_alias
                                    ) &&
                                      header?.value?.[0] &&
                                      (() => {
                                        const item = header.value[0];
                                        const alias = item.label
                                          ?.split("-$")
                                          ?.at(-1)
                                          ?.split(".")
                                          ?.at(-1)
                                          ?.replace(/^\$/, "");

                                        return (
                                          <div
                                            className="condition-fields d-flex"
                                            key={`condition_${alias}`}
                                          >
                                            <Checkbox
                                              sx={{
                                                "&:hover": {
                                                  bgcolor: "transparent",
                                                },
                                                margin: 0,
                                                padding: 0,
                                              }}
                                              disableRipple
                                              color="default"
                                              checkedIcon={<BpCheckedIcon />}
                                              icon={<BpIcon />}
                                              value={`condition_${alias}`}
                                              onChange={({
                                                target: { checked },
                                              }) => {
                                                handleSelectedField(
                                                  alias,
                                                  checked,
                                                  setSelectedConditionField,
                                                  header.id
                                                );
                                              }}
                                            />
                                            <label className="ml-2 m-0">
                                              {lang["condition_fields"]}
                                            </label>
                                          </div>
                                        );
                                      })()}

                                    {/* {selectedFields.includes(
                                      header.fomular_alias
                                    ) &&
                                      header?.value?.map((item) => {
                                        const alias = item.label
                                          ?.split("-$")
                                          ?.at(-1)
                                          ?.split(".")
                                          ?.at(-1)
                                          ?.replace(/^\$/, "");

                                        return (
                                          <div
                                            className="condition-fields d-flex"
                                            key={`condition_${alias}`}
                                          >
                                            <Checkbox
                                              sx={{
                                                "&:hover": {
                                                  bgcolor: "transparent",
                                                },
                                                margin: 0,
                                                padding: 0,
                                              }}
                                              disableRipple
                                              color="default"
                                              checkedIcon={<BpCheckedIcon />}
                                              icon={<BpIcon />}
                                              value={`condition_${alias}`}
                                              onChange={({
                                                target: { checked },
                                              }) => {
                                                handleSelectedField(
                                                  alias,
                                                  checked,
                                                  setSelectedConditionField,
                                                  header.id
                                                );
                                              }}
                                            />
                                            <label className="ml-2 m-0">
                                              {lang["condition_fields"]}
                                            </label>
                                          </div>
                                        );
                                      })} */}
                                  </td>
                                  <td
                                    style={{
                                      display:
                                        export_excel_type.export_excel_type ===
                                          "statistic"
                                          ? "none"
                                          : "table-cell",
                                    }}
                                  >
                                    {selectedFields.includes(
                                      header.fomular_alias
                                    ) &&
                                      header?.value?.[0] &&
                                      (() => {
                                        const item = header.value[0];
                                        const alias = item.label
                                          ?.split("-$")
                                          ?.at(-1)
                                          ?.split(".")
                                          ?.at(-1)
                                          ?.replace(/^\$/, "");

                                        return (
                                          <div
                                            className="unique-fields d-flex"
                                            key={`unique_${alias}`}
                                          >
                                            <Checkbox
                                              sx={{
                                                "&:hover": {
                                                  bgcolor: "transparent",
                                                },
                                                margin: 0,
                                                padding: 0,
                                              }}
                                              disableRipple
                                              color="default"
                                              checkedIcon={<BpCheckedIcon />}
                                              icon={<BpIcon />}
                                              value={`unique_${alias}`}
                                              onChange={({
                                                target: { checked },
                                              }) => {
                                                handleSelectedField(
                                                  alias,
                                                  checked,
                                                  setSelectedUniqueField,
                                                  header.id
                                                );
                                              }}
                                            />
                                            <label className="ml-2 m-0">
                                              {lang["unique_fields"]}
                                            </label>
                                          </div>
                                        );
                                      })()}

                                    {/* {selectedFields.includes(
                                      header.fomular_alias
                                    ) &&
                                      header?.value?.map((item) => {
                                        const alias = item.label
                                          ?.split("-$")
                                          ?.at(-1)
                                          ?.split(".")
                                          ?.at(-1)
                                          ?.replace(/^\$/, "");

                                        return (
                                          <div
                                            className="unique-fields d-flex"
                                            key={`unique_${alias}`}
                                          >
                                            <Checkbox
                                              sx={{
                                                "&:hover": {
                                                  bgcolor: "transparent",
                                                },
                                                margin: 0,
                                                padding: 0,
                                              }}
                                              disableRipple
                                              color="default"
                                              checkedIcon={<BpCheckedIcon />}
                                              icon={<BpIcon />}
                                              value={`unique_${alias}`}
                                              onChange={({
                                                target: { checked },
                                              }) => {
                                                handleSelectedField(
                                                  alias,
                                                  checked,
                                                  setSelectedUniqueField,
                                                  header.id
                                                );
                                              }}
                                            />
                                            <label className="ml-2 m-0">
                                              {lang["unique_fields"]}
                                            </label>
                                          </div>
                                        );
                                      })} */}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>

                    {/* thinh can sua */}
                    <h5 class="mt-4 mb-2">{lang["select export type"]}:</h5>
                    <div
                      className="ml-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <label style={{ display: "flex", alignItems: "center" }}>
                        <Checkbox
                          sx={{
                            "&:hover": { bgcolor: "transparent" },
                            margin: 0,
                            padding: 0,
                          }}
                          value="excel"
                          checked={exportType === "excel"}
                          onChange={() => setExportType("excel")}
                        />
                        <span className="ml-2">Excel</span>
                      </label>
                      <label
                        className="ml-4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Checkbox
                          sx={{
                            "&:hover": { bgcolor: "transparent" },
                            margin: 0,
                            padding: 0,
                          }}
                          value="csv"
                          checked={exportType === "csv"}
                          onChange={() => setExportType("csv")}
                        />
                        <span className="ml-2">CSV</span>
                      </label>
                    </div>

                    <h5 class="mt-4 mb-2">{lang["preview data"]}: </h5>
                    {(selectedFields && selectedFields.length > 0) ||
                      selectedStats.length > 0 ? (
                      <></>
                    ) : (
                      <>{lang["preview.content"]}</>
                    )}

                    {(selectedFields && selectedFields.length > 0) ||
                      current & (current.length > 0) ||
                      (dataStatis && dataStatis.length > 0) ? (
                      <div class="table-responsive">
                        <>
                          <table class="table table-striped excel-preview">
                            <thead>
                              {selectedFields.map((field) => {
                                const header = apiDataName?.find(
                                  (header) => header?.fomular_alias === field
                                );

                                return (
                                  <th key={field}>
                                    {header
                                      ? header?.field_name ||
                                      header?.display_name
                                      : field}
                                  </th>
                                );
                              })}
                            </thead>
                            <tbody>
                              {current.map((row, rowIndex) => {
                                return (
                                  <tr key={rowIndex}>
                                    {apiDataName.map((field) => {
                                      return (
                                        <td
                                          key={field}
                                          style={{ width: "100px" }}
                                        >
                                          {row[field?.value?.[0]?.value]}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                              {dataStatis && dataStatis.length > 0 ? (
                                <tr>
                                  {selectedStats.map((statAlias, index) => {
                                    const stat = dataStatis.find(
                                      (stat) => stat.fomular_alias === statAlias
                                    );

                                    return (
                                      <td
                                        key={index}
                                        class="font-weight-bold"
                                        colspan={`${selectedFields.length + 1}`}
                                        style={{ textAlign: "right" }}
                                      >
                                        {stat
                                          ? `${stat.display_name}: ${stat.result}`
                                          : ""}
                                      </td>
                                    );
                                  })}
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                          {/* <div
                            className="d-flex justify-content-between align-items-center w-100"
                            style={{ marginTop: "1px" }}
                          >
                            <div className="col-sm-8 p-0">
                              <p>
                                {lang["show"]}{" "}
                                {functions.formatNumber(indexOfFirst + 1)} -{" "}
                                {functions.formatNumber(
                                  indexOfFirst + apiData?.length
                                )}{" "}
                                {`${lang["of"]} `}
                                {loadingResult ? (
                                  <img
                                    width={20}
                                    className="mb-1"
                                    src="/images/icon/load.gif"
                                    alt="Loading..."
                                  ></img>
                                ) : (
                                  functions.formatNumber(sumerize)
                                )}{" "}
                                {lang["results"]}
                              </p>
                            </div>
                            <div className="col-sm-4 p-0">
                              <nav aria-label="Page navigation example">
                                <ul className="pagination mb-0 justify-content-end">
                                  <li
                                    className={`page-item ${
                                      currentPage === 1 ? "disabled" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => paginate(1, true)}
                                    >
                                      &#8810;
                                    </button>
                                  </li>
                                  <li
                                    className={`page-item ${
                                      currentPage === 1 ? "disabled" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        paginate(
                                          Math.max(1, currentPage - 1),
                                          false
                                        )
                                      }
                                    >
                                      &laquo;
                                    </button>
                                  </li>
                                  {currentPage > 2 && (
                                    <li className="page-item">
                                      <span className="page-link">...</span>
                                    </li>
                                  )}

                                  {Array(totalPages)
                                    .fill()
                                    .map((_, index) => {
                                      if (
                                        index + 1 === currentPage ||
                                        (index + 1 >= currentPage - 1 &&
                                          index + 1 <= currentPage + 1)
                                      ) {
                                        return (
                                          <li
                                            key={index}
                                            className={`page-item ${
                                              currentPage === index + 1
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <p
                                              className="page-link"
                                              onClick={() =>
                                                paginate(index + 1, false)
                                              }
                                            >
                                              {functions.formatNumber(
                                                index + 1
                                              )}
                                            </p>
                                          </li>
                                        );
                                      }
                                      return null;
                                    })}
                                  {currentPage < totalPages - 1 && (
                                    <li className="page-item">
                                      <span className="page-link">...</span>
                                    </li>
                                  )}

                                  <li
                                    className={`page-item ${
                                      currentPage === totalPages
                                        ? "disabled"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        paginate(
                                          Math.min(totalPages, currentPage + 1),
                                          false
                                        )
                                      }
                                    >
                                      &raquo;
                                    </button>
                                  </li>
                                  <li
                                    className={`page-item ${
                                      currentPage === totalPages
                                        ? "disabled"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => paginate(totalPages, true)}
                                    >
                                      &#8811;
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                            </div>
                          </div> */}
                        </>
                      </div>
                    ) : null}
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    onClick={() => {
                      if (selectedFields.length === 0) {
                        Swal.fire({
                          title: lang["faild"],
                          text: lang["export.content.error"],
                          icon: "error",
                          showConfirmButton: true,
                          customClass: {
                            confirmButton:
                              "swal2-confirm my-confirm-button-class",
                          },
                        });
                      } else {
                        const mapped = database.fields.filter((field) =>
                          dataTables?.[0]?.foreign_keys.some(
                            ({ field_id }) => field_id === field.id
                          )
                        );
                        const data_for_filtering = {};
                        for (const k in exportedData) {
                          if (exportedData[k]) {
                            if (k === "from") {
                              if (exportedData.from == 0) {
                                exportedData[k] = 0;
                              } else {
                                exportedData[k] -= 1;
                              }
                            }
                            if (typeof exportedData[k] === "string") {
                              exportedData[k] = exportedData[k].trim();
                              // if (!isNaN(exportedData[k])) {
                              //   if (
                              //     mapped.find(
                              //       ({ fomular_alias }) => fomular_alias === k
                              //     )
                              //   ) {
                              exportedData[k] = exportedData[k];
                              //   } else {
                              // exportedData[k] = Number(exportedData[k]);
                              //   }
                              // }
                            }
                            data_for_filtering[k] = exportedData[k];
                          }
                        }

                        const dataExists =
                          Object.keys(data_for_filtering).length > 0;
                        // if (
                        //   (!dataExists && countData > 100000) ||
                        //   dataTo - dataFrom > 100000
                        // ) {
                        //   Swal.fire({
                        //     title: lang["faild"],
                        //     text: lang["export.content.error.amount"],
                        //     icon: "error",
                        //     showConfirmButton: true,
                        //     customClass: {
                        //       confirmButton:
                        //         "swal2-confirm my-confirm-button-class",
                        //     },
                        //   });
                        // } else {
                        Export({ data_for_filtering });
                        // }
                      }
                    }}
                    class="btn btn-success "
                    data-dismiss="modal"
                  >
                    {lang["export"]}{" "}
                  </button>
                  <button
                    type="button"
                    data-dismiss="modal"
                    onClick={handleCloseModal}
                    className="btn btn-danger"
                  >
                    {lang["btn.close"]}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* modal add*/}
          {isModalAdd ? (
            <div class={`modal fade`} id="modalAdd">
              <div class="modal-dialog modal-dialog-center">
                <div class="modal-content">
                  <div class="modal-header align-items-center">
                    <h4 class="modal-title">{lang["add"]}</h4>
                    <div style={{ maxWidth: "10%" }}>
                      <button
                        type="button"
                        className="close pb-0 pt-0"
                        onClick={handleCloseModal}
                        data-dismiss="modal"
                        style={{
                          color: "rgb(255, 102, 85)",
                          fontSize: "35px",
                          opacity: 1,
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                  <div class="modal-body export">
                    <RenderInputPost
                      key={refreshPage}
                      isData={isData}
                      isModal={isModalAdd}
                      handleCloseModal={handleCloseModal}
                      setRefreshPage={setRefreshPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {/* modal edit*/}
          {isModal ? (
            <div class={`modal fade`} id="modalEdit">
              <div class="modal-dialog modal-dialog-center">
                <div class="modal-content">
                  <div class="modal-header align-items-center">
                    <h4 class="modal-title">{lang["edit"]}</h4>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="close pb-0 pt-0"
                        onClick={handleCloseModal}
                        data-dismiss="modal"
                        style={{
                          color: "rgb(255, 102, 85)",
                          fontSize: "35px",
                          opacity: 1,
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                  <div class="modal-body export render-modal">
                    <RenderInputPut
                      key={refreshPage}
                      isData={isData}
                      isModal={isModal}
                      handleCloseModal={handleCloseModal}
                      setRefreshPage={setRefreshPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {/* modal detail */}
          {isModal ? (
            <div class={`modal fade render-detail`} id="modalDetail">
              <div class="modal-dialog modal-dialog-center">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">{lang["detail"]}</h4>
                    <button
                      type="button"
                      className="close pb-0"
                      onClick={handleCloseModal}
                      data-dismiss="modal"
                      style={{
                        color: "rgb(255, 102, 85)",
                        fontSize: "35px",
                        opacity: 1,
                      }}
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body export render-modal">
                    <RenderDataDetail
                      isData={isData}
                      isModal={isModal}
                      buttonId={buttonId}
                      handleCloseModa={handleCloseModal}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {isModal ? (
            <RenderModal
              key={refreshKey}
              idModal={idModal}
              setIdModal={setIdModal}
              setModal={setModal}
              isModal={isModal}
              page={page}
              component={dataBtnLink}
              buttonId={buttonId}
              apiData={apiData}
              redirectToInput={redirectToInput}
              redirectToInputPUT={redirectToInputPUT}
              handleDelete={handleDelete}
              handleSearchClick={handleSearchClick}
              exportToCSV={exportToCSV}
              handleViewDetail={handleViewDetail}
              handleTable_Param={handleTable_Param}
              handleRedirect={handleRedirect}
              handleRedirectTable={handleRedirectTable}
              exportFile={exportFile}
              exportFile_PK={exportFile_PK}
              redirectToImportData={redirectToImportData}
              dataCheck={dataCheck}
              submitButton_Custom={submitButton_Custom}
              dataPrivileges={dataPrivileges}
              privilegesDetail={privilegesDetail}
              _user={user}
              isParam={isParam}
              isParamSearch={paramSearch}
              anotherModal={anotherModal}
              isParamTable={isParamTable}
              setRenderTable={setRenderTable}
              setAnotherModal={setAnotherModal}
              setModalTable={setModalTable}
              popupStyles={popupStyles}
            />
          ) : null}
          {isModalTable &&
            dynamicModals
              // .filter(({ closing }) => !closing)
              .map((item, index) => {
                return (
                  <>
                    <div
                      className={`modal fade ${item.closing ? "fade-out" : ""}`}
                      id={item.id}
                      // aria-labelledby={idModal}
                      data-backdrop="static"
                      // style={{ display: "block" }}
                      // style={{ display: renderTable ? "none" : "block" }}
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" style={item.popupStyles}>
                        <div className="modal-content custome">
                          <div className="modal-header justify-content-end">
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              onClick={() => {
                                setDynamicModals((prev) =>
                                  prev.map((m) =>
                                    m.id === item.id
                                      ? { ...m, closing: true }
                                      : m
                                  )
                                );

                                setTimeout(() => {
                                  setDynamicModals((prev) =>
                                    prev.filter((m) => m.id !== item.id)
                                  );
                                  setModal(false);
                                }, 300);
                                setModal(false);
                              }}
                            >
                              &times;
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            style={{
                              maxHeight: "82vh",
                              overflowY: "auto",
                              overflowX: "unset",
                            }}
                          >
                            <SearchingDataProvider>
                              <RenderUI
                                page={page}
                                component={item.dataTable}
                                apiData={apiData}
                                redirectToInput={redirectToInput}
                                redirectToInputPUT={redirectToInputPUT}
                                handleDelete={handleDelete}
                                handleSearchClick={handleSearchClick}
                                exportToCSV={exportToCSV}
                                handleViewDetail={handleViewDetail}
                                handleTable_Param={handleTable_Param}
                                handleRedirect={handleRedirect}
                                handleRedirectTable={handleRedirectTable}
                                exportFile={exportFile}
                                exportFile_PK={exportFile_PK}
                                buttonId={buttonId}
                                redirectToImportData={redirectToImportData}
                                dataCheck={dataCheck}
                                submitButton_Custom={submitButton_Custom}
                                dataPrivileges={dataPrivileges}
                                privilegesDetail={privilegesDetail}
                                isParam={item.isParamTable}
                                isParamSearch={item.paramSearchTable}
                                anotherModal={anotherModal}
                                setAnotherModal={setAnotherModal}
                                _user={user}
                              />
                            </SearchingDataProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          {/* modal export excel*/}
          <div class={`modal `} id="exportExcel_PK">
            <div class="modal-dialog modal-dialog-center">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{lang["export"]}</h4>
                  <button
                    type="button"
                    class="close"
                    onClick={handleCloseModal}
                    data-dismiss="modal"
                  >
                    &times;
                  </button>
                </div>
                <div class="modal-body">
                  <form>
                    <h5 class="mt-2 mb-2">{lang["select fields"]}:</h5>
                    <div className="select-all-checkbox ml-2">
                      <label class="pointer">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAllChange}
                        />
                        <span className="ml-2 font-weight-bold">
                          {lang["selectall"]}
                        </span>
                      </label>
                    </div>

                    <div className="checkboxes-grid ml-4 row">
                      {apiDataName?.map((header, index) => {
                        return (
                          <div className="col-md-6 mb-2">
                            <label class="pointer" key={index}>
                              <input
                                type="checkbox"
                                value={header.fomular_alias}
                                checked={selectedFields.includes(
                                  header.fomular_alias
                                )}
                                onChange={handleFieldChange}
                              />
                              <span className="ml-2">
                                {header.display_name || header.field_name}
                              </span>
                            </label>
                            {selectedFields.includes(header.fomular_alias) ? (
                              <div className="row ml-3">
                                <label className="col-sm-12">
                                  <input
                                    type="checkbox"
                                    value={`condition_${header.fomular_alias}`}
                                    onChange={({ target: { checked } }) => {
                                      handleSelectedFieldTID(
                                        header.fomular_alias,
                                        checked,
                                        setSelectedConditionField
                                      );
                                    }}
                                  />
                                  <span className="ml-2">
                                    {lang["condition_fields"]}
                                  </span>
                                </label>
                                <label className="col-sm-12">
                                  <input
                                    type="checkbox"
                                    value={`condition_${header.fomular_alias}`}
                                    onChange={({ target: { checked } }) => {
                                      handleSelectedFieldTID(
                                        header.fomular_alias,
                                        checked,
                                        setSelectedUniqueField
                                      );
                                    }}
                                  />
                                  <span className="ml-2">
                                    {lang["unique_fields"]}
                                  </span>
                                </label>
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </div>

                    <h5 class="mt-4 mb-2">{lang["preview data"]}: </h5>
                    {(selectedFields && selectedFields.length > 0) ||
                      selectedStats.length > 0 ? (
                      <></>
                    ) : (
                      <>{lang["preview.content"]}</>
                    )}

                    {(selectedFields && selectedFields.length > 0) ||
                      current & (current.length > 0) ||
                      (dataStatis && dataStatis.length > 0) ? (
                      <div class="table-responsive">
                        <table class="table table-striped excel-preview">
                          <thead class="sticky-header">
                            {selectedFields.map((field) => {
                              const header = apiDataName.find(
                                (header) => header.fomular_alias === field
                              );
                              return (
                                <th key={field} className="header-cell">
                                  {header
                                    ? header.field_name || header.display_name
                                    : field}
                                </th>
                              );
                            })}
                          </thead>
                          <tbody>
                            {current.slice(0, 5).map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {selectedFields.map((field) => (
                                  <td
                                    className="cell"
                                    key={field}
                                    title={formatIfDate(row[field])}
                                  >
                                    {formatIfDate(row[field])}
                                  </td>
                                ))}
                              </tr>
                            ))}
                            {dataStatis && dataStatis.length > 0 ? (
                              <tr>
                                {selectedStats.map((statAlias, index) => {
                                  const stat = dataStatis.find(
                                    (stat) => stat.fomular_alias === statAlias
                                  );
                                  return (
                                    <td
                                      key={index}
                                      class="font-weight-bold"
                                      colspan={`${selectedFields.length + 1}`}
                                      style={{ textAlign: "right" }}
                                    >
                                      {stat
                                        ? `${stat.display_name}: ${stat.result}`
                                        : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </div>
                    ) : null}
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    onClick={() => {
                      if (selectedFields.length === 0) {
                        Swal.fire({
                          title: lang["faild"],
                          text: lang["export.content.error"],
                          icon: "error",
                          showConfirmButton: true,
                          customClass: {
                            confirmButton:
                              "swal2-confirm my-confirm-button-class",
                          },
                        });
                      } else {
                        // apiData.export_excel_typ
                        Export(apiData);
                      }
                    }}
                    class="btn btn-success "
                    data-dismiss="modal"
                  >
                    {lang["export"]}{" "}
                  </button>
                  <button
                    type="button"
                    data-dismiss="modal"
                    onClick={handleCloseModal}
                    class="btn btn-danger"
                  >
                    {lang["btn.close"]}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* modal import excel/csv data */}
          <div class={`modal `} id="importExcel">
            <div class="modal-dialog modal-dialog-center">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{lang["import data"]}</h4>
                  <button
                    type="button"
                    class="close"
                    onClick={handleCloseModal}
                    data-dismiss="modal"
                  >
                    &times;
                  </button>
                </div>
                <div class="modal-body">
                  <form>
                    <>
                      <CustomFileInput />
                    </>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    data-dismiss="modal"
                    class="btn btn-danger"
                  >
                    {lang["btn.close"]}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <Step /> */}
          {layoutId === 0 ? (
            <Layout0
              activeTab={activeTab}
              page={page}
              statusActive={statusActive}
              dataCheck={dataCheck}
            />
          ) : layoutId === 1 ? (
            <Layout1
              activeTab={activeTab}
              page={page}
              statusActive={statusActive}
              dataCheck={dataCheck}
            />
          ) : layoutId === 2 ? (
            <Layout_active
              page={page}
              statusActive={statusActive}
              dataCheck={dataCheck}
            />
          ) : layoutId === 3 ? (
            <Layout_keys
              page={page}
              statusActive={statusActive}
              dataCheck={dataCheck}
            />
          ) : layoutId === 4 ? (
            <Layout_chart
              page={page}
              statusActive={statusActive}
              dataCheck={dataCheck}
            />
          ) : null}
        </div>
        <SearchingDataProvider>
          <RenderUI
            page={page}
            component={dataUi}
            apiData={apiData}
            redirectToInput={redirectToInput}
            redirectToInputPUT={redirectToInputPUT}
            handleDelete={handleDelete}
            handleSearchClick={handleSearchClick}
            exportToCSV={exportToCSV}
            handleViewDetail={handleViewDetail}
            handleTable_Param={handleTable_Param}
            handleRedirect={handleRedirect}
            handleRedirectTable={handleRedirectTable}
            exportFile={exportFile}
            exportFile_PK={exportFile_PK}
            redirectToImportData={redirectToImportData}
            dataCheck={dataCheck}
            submitButton_Custom={submitButton_Custom}
            dataPrivileges={dataPrivileges}
            privilegesDetail={privilegesDetail}
            handleButtonLink={handleButtonLink}
            _user={user}
          />
        </SearchingDataProvider>
      </div>
    </div>
  );
};
export default COMPONENT;
